import script from "./EditStructure.vue?vue&type=script&setup=true&lang=js"
export * from "./EditStructure.vue?vue&type=script&setup=true&lang=js"

import "./EditStructure.vue?vue&type=style&index=0&id=2ac491d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ac491d4"]])

export default __exports__